import type { Ref } from "react";
import { getNameInitials } from "./participantName";

export function LivestreamHostPreviewVideo({
  videoEnabled,
  name,
  videoRef,
}: {
  videoEnabled: boolean;
  name: string;
  videoRef: Ref<HTMLVideoElement>;
}) {
  const displayName = name.trim() || "Host";

  return (
    <div className="relative h-full w-full overflow-hidden bg-black">
      {videoEnabled ? (
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className="h-full w-full object-cover object-center"
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className="flex h-24 w-24 items-center justify-center rounded-full bg-zinc-800 text-2xl font-semibold text-white sm:h-32 sm:w-32 sm:text-3xl"
            aria-label={displayName}
          >
            {getNameInitials({ name: displayName })}
          </div>
        </div>
      )}
      <div className="pointer-events-none absolute top-[max(0.75rem,env(safe-area-inset-top))] right-3 z-20 rounded-full border border-white/20 bg-black/55 px-2.5 py-1 text-xs font-medium text-white backdrop-blur-sm sm:right-4">
        Preview
      </div>
    </div>
  );
}
